import { IDonorRecord } from 'modules/dashboard/types/donor';

import { COLUMN_REGISTRY } from './columnRegistry';

import { ColumnBuildContext, ColumnKey, ICsvBuildOpts } from '../types';

export function buildCsvColumns(
  keys: ColumnKey[],
  ctx: ColumnBuildContext,
  opts: ICsvBuildOpts
): Array<{ label: string; value: (d: IDonorRecord) => string }> {
  return keys.flatMap((key) => {
    if (key in opts.visibleColumns && !opts.visibleColumns[key]) return [];
    return COLUMN_REGISTRY[key].csvColumns
      .filter((col) => !col.includeWhen || col.includeWhen(opts))
      .map((col) => ({
        label: col.label,
        value: (d: IDonorRecord) => col.value(d, ctx),
      }));
  });
}
